import { Pipe, PipeTransform } from '@angular/core';
import { StoreType, storeTypes } from '../../../models/business-information.model';

const DEFAULT_ICON = 'assets/img/restaurants/125x125/cuisine-1.jpg';
const ICON_MAP: Record<StoreType | 'all', string> = {
  [storeTypes.nail]: 'assets/icons/nails-icon.png',
  [storeTypes.spa]: 'assets/icons/spa-icon.png',
  [storeTypes.pets]: 'assets/icons/pet-icon.png',
  [storeTypes.waxing]: 'assets/icons/waxing-icon.png',
  [storeTypes.hair]: 'assets/icons/hair-icon.png',
  [storeTypes.tattoo]: 'assets/icons/tattoo-icon.png',
  all: 'assets/icons/all.svg'
};

@Pipe({
  name: 'businessTypeToIcon'
})
export class BusinessTypeToIconPipe implements PipeTransform {
  /**
   * Transforms a StoreType into its corresponding icon path.
   * @param value The StoreType to transform (e.g., 'nail', 'spa').
   * @returns The string path of the icon.
   */
  transform(value: StoreType | 'all' | undefined | null): string {
    if (!value || !ICON_MAP[value]) {
      return DEFAULT_ICON;
    }
    return ICON_MAP[value];
  }
}

